@if (loaded) {
  <div class="dashboard-container">
    <app-dashboard
      #dashboard
      [id]="dashboardId"
      [isInPortal]="true"
      [showHeader]="false"
    ></app-dashboard>
  </div>
}
